import React from 'react';
import { Checkbox, Divider, Radio, Row } from 'antd';
import moment from 'moment';
import { SuccessButton } from 'components/common';
import { SmartNumberInput, SmartScannerInput, SmartSpace } from '../SmartComponent';
import { ScanRecvCountType, ScanRecvLotPolicy, ScanRecvRatioType } from './context';

type Props = ReduxStateProps & {
  onChangeScanRecvCountType?: Function;
  onChangeScanRecvLotPolicy?: Function;
  onChangeScanRecvLotUniNum?: Function;
  onChangeScanRecvRatio?: Function;
  onChangeScanRecvRatioType?: Function;
};

const ScanQtySetting = (props: Props) => {
  const { useState } = React;
  const { state } = props;
  const [lotNumberInputVersion, setLotNumberInputVersion] = useState(0);
  const [scanRecvCountType, setScanRecvCountType] = useState(state.scanRecvCountType);
  const [scanRecvLotPolicy, setScanRecvLotPolicy] = useState(state.scanRecvLotPolicy);
  const [scanRecvLotUniNum, setScanRecvLotUniNum] = useState(state.scanRecvLotUniNum);
  const [scanRecvRatio, setScanRecvRatio] = useState(state.scanRecvRatio);
  const [scanRecvRatioType, setScanRecvRatioType] = useState(state.scanRecvRatioType);

  const createLotNumUsingDate = () => {
    const ln = moment().format('YYYYMMDD');

    setScanRecvLotUniNum(ln);
    setLotNumberInputVersion(lotNumberInputVersion + 1);

    if (props.onChangeScanRecvLotUniNum) props.onChangeScanRecvLotUniNum(ln);
  };

  const onChangeScanRecvCountType = (evt: any) => {
    const ct = evt.target.checked ? ScanRecvCountType.Custom : ScanRecvCountType.Default;

    setScanRecvCountType(ct);

    if (props.onChangeScanRecvCountType) props.onChangeScanRecvCountType(ct);
  };

  const onChangeScanRecvLotPolicy = (evt: any) => {
    const lp = evt.target.checked ? ScanRecvLotPolicy.AssignSameLot : ScanRecvLotPolicy.InputManually;

    setLotNumberInputVersion(lotNumberInputVersion + 1);
    setScanRecvLotPolicy(lp);

    if (props.onChangeScanRecvLotPolicy) props.onChangeScanRecvLotPolicy(lp);
  };

  const onChangeScanRecvLotUniNum = (evt: any) => {
    const ln = evt.target.value;

    setScanRecvLotUniNum(ln);

    if (props.onChangeScanRecvLotUniNum) props.onChangeScanRecvLotUniNum(ln.trim());
  };

  const onChangeScanRecvRatio = (ratio: any) => {
    setScanRecvRatio(ratio);

    if (props.onChangeScanRecvRatio) props.onChangeScanRecvRatio(ratio);
  };

  const onChangeScanRecvRatioType = (evt: any) => {
    const rt = evt.target.value;

    setScanRecvRatioType(rt);

    if (props.onChangeScanRecvRatioType) props.onChangeScanRecvRatioType(rt);
  };

  return (
    <SmartSpace className="mb-0 mt-20">
      <Checkbox
        defaultChecked={scanRecvCountType === ScanRecvCountType.Custom}
        onChange={onChangeScanRecvCountType}
      >
        Qty of one scan
      </Checkbox>
      <Divider />
      <Radio.Group
        disabled={scanRecvCountType === ScanRecvCountType.Default}
        onChange={onChangeScanRecvRatioType}
        value={scanRecvRatioType}
      >
        <Radio value={ScanRecvRatioType.FixedRatio}>
          <Row align="middle">
            <span className="mr-8">Default Qty</span>
            <SmartNumberInput
              className="num-input nw-60 h-40"
              defaultValue={scanRecvRatio}
              disabled={scanRecvCountType === ScanRecvCountType.Default}
              min={1}
              onChange={onChangeScanRecvRatio}
            />
          </Row>
        </Radio>
        <Radio style={{marginTop: 15}} value={ScanRecvRatioType.Unreceived}>
          The remaining unreceived
        </Radio>
      </Radio.Group>
      {state.enableLot && (<>
        <Divider />
        <Checkbox
          defaultChecked={scanRecvLotPolicy === ScanRecvLotPolicy.AssignSameLot}
          onChange={onChangeScanRecvLotPolicy}
        >
          Assign the same LOT# to all SKU
        </Checkbox>
        <Row align="middle" className="mt-15">
          <span className="mr-8">Specify LOT#</span>
          <SmartScannerInput
            allowClear
            className="fs-22 h-40"
            defaultValue={scanRecvLotUniNum}
            disabled={scanRecvLotPolicy === ScanRecvLotPolicy.InputManually}
            onChange={onChangeScanRecvLotUniNum}
            style={{width: 'calc(100% - 96px)'}}
            version={lotNumberInputVersion}
          />
        </Row>
        <Row className="mt-20" justify="center">
          <SuccessButton
            disabled={scanRecvLotPolicy === ScanRecvLotPolicy.InputManually}
            onClick={createLotNumUsingDate}
            size="large"
          >
            Create LOT# Using Date
          </SuccessButton>
        </Row>
      </>)}
    </SmartSpace>
  );
};

export default ScanQtySetting;
